const initialState = {
    formKritikSaran: {
        Name : "",
        Email : "",
        Mobile : "",
        DatasetSuggestion : "",
        DatasetReason : "",
        UserSuggestionCategoryId : "",
        DatasetCategoryId : "",
    },
    dataSuggestionCategories: false,
    dataDatasetCategories: false,
}

const kritikSaranReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FORM_KRITIK_SARAN':
            return {
                ...state,
                formKritikSaran: {
                    ...state.formKritikSaran,
                    [action.formType]: action.formValue
                }
            }
        case 'RESET_FORM_KRITIK_SARAN':
            return { ...state, formKritikSaran: initialState.formKritikSaran }
        case 'DATA_SUGGESTION_CATEGORIES':
            return { ...state, dataSuggestionCategories: action.payload }
        case 'DATA_DATASET_CATEGORIES':
            return { ...state, dataDatasetCategories: action.payload }
        default:
            return state
    }
}

export default kritikSaranReducer;